export const popupBlockAnimation = {
	initial: { opacity: 0, scale: 0 },
	animate: {
		opacity: 1,
		scale: 1,
		transition: {
			duration: 0.2,
		},
	},
	exit: {
		opacity: 0,
		scale: 0,
		transition: {
			duration: 0.2,
		},
	},
};
